export default __webpack_public_path__ + "static/media/twitter.ba8e14ef.svg";